import React, { useEffect, useState } from 'react';
import { Modal, Button, Table, Form } from 'react-bootstrap';
import { fetchMatchHistory, submitReportMatch } from '../Api';

const MatchHistoryModal = ({ show, onHide }) => {
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedMatch, setSelectedMatch] = useState(null);
    const winningTeam = (match) => {
        return match.members.find(m => m.score === true)?.team;
    };

    const [reportModalOpen, setReportModalOpen] = useState(false);
    const [reportText, setReportText] = useState('');

    useEffect(() => {
        if (show) {
            setLoading(true);
            fetchMatchHistory()
                .then(data => {
                    setMatches(data);
                    setLoading(false);
                })
                .catch(err => {
                    console.error('Failed to fetch match history:', err);
                    setLoading(false);
                });
        }
    }, [show]);

    const getScore = (match) => {
        const team1 = match.members.some(m => m.team === 1 && m.score === true) ? 1 : 0;
        const team2 = match.members.some(m => m.team === 2 && m.score === true) ? 1 : 0;
        return `${team1}:${team2}`;
    };

    const getPlayers = (match) => {
        const team1 = match.members.filter(m => m.team === 1).map(m => m.full_name);
        const team2 = match.members.filter(m => m.team === 2).map(m => m.full_name);
        return { team1, team2 };
    };

    const handleClose = () => {
        setSelectedMatch(null); // reset to match list on close
        onHide();
    };

    const handleBack = () => {
        setSelectedMatch(null);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {selectedMatch
                        ? `${selectedMatch.sport_name}: ${selectedMatch.match_type} (${selectedMatch.player})`
                        : 'Match History'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {loading ? (
                    <p>Loading...</p>
                ) : selectedMatch ? (
                    <>


                        <div className="mt-3">
                            <Button variant="danger" onClick={() => setReportModalOpen(true)}>
                                Report
                            </Button>
                        </div>
                        {/* Match Detail View */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <p><strong>Date:</strong> <span className="badge bg-light text-dark">{new Date(selectedMatch.date).toLocaleDateString()}</span></p>
                            </div>
                            <div className="col-md-6">
                                <p><strong>Score:</strong> <span className="badge bg-light text-dark">{getScore(selectedMatch)}</span></p>
                            </div>
                        </div>

                        <div className="mb-3">
                            <p><strong>Sport:</strong> <span className="badge bg-light text-dark">{selectedMatch.sport_name}</span></p>
                            <p><strong>Match Type:</strong> <span className="badge bg-light text-dark">{selectedMatch.match_type}</span> | <span className="badge bg-light text-dark">{selectedMatch.player}</span></p>
                        </div>

                        <div>
                            <p><strong>Players:</strong></p>
                            <div className="row">
                                {[1, 2].map(teamNumber => (
                                    <div key={teamNumber} className={`col-md-6 ${teamNumber === 2 ? 'mt-3 mt-md-0' : ''}`}>
                                        <ul className="list-group list-group-flush border rounded p-2 bg-light">
                                            {selectedMatch.members
                                                .filter(m => m.team === teamNumber)
                                                .map((player, idx) => {
                                                    const isCurrent = player.is_current_user;
                                                    const winningTeamNumber = selectedMatch.members.find(m => m.score === true)?.team;
                                                    const isWinner = selectedMatch.is_counted && player.team === winningTeamNumber;
                                                    const isLoser = selectedMatch.is_counted && player.team !== winningTeamNumber;

                                                    return (
                                                        <li key={idx} className="list-group-item bg-transparent border-0 py-1">
                                                            {isCurrent ? '(You)' : player.full_name}{' '}
                                                            {isWinner ? <span style={{ color: 'green' }}>✓</span> : isLoser ? <span style={{ color: 'red' }}>✗</span> : null}
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </div>


                    </>
                ) : (
                    <>
                        {/* Match List View */}
                        {matches.length === 0 ? (
                            <p>No match history found.</p>
                        ) : (
                            <Table bordered responsive hover>
                                <thead className="table-light">
                                    <tr>
                                        <th>Sport</th>
                                        <th>Game Type</th>        {/* New column */}
                                        <th>Score Counted</th>         {/* New column */}
                                        <th>Winner (Yes/No)</th>
                                        <th>Date</th>
                                        <th>Status</th> {/* new column */}

                                    </tr>
                                </thead>
                                <tbody>
                                    {matches.map(match => {
                                        const currentUser = match.members.find(m => m.is_current_user) || match.members[0];

                                        // Determine winning team
                                        const winningTeam = match.members.find(m => m.score === true)?.team;

                                        // Determine Winner text
                                        let winnerText = '—';
                                        let color = 'black';

                                        if (!match.is_counted || winningTeam === undefined) {
                                            winnerText = 'Not Declared';
                                            color = 'gray';
                                        } else if (currentUser.team === winningTeam) {
                                            winnerText = 'Win';
                                            color = 'green';
                                        } else {
                                            winnerText = 'Loss';
                                            color = 'red';
                                        }

                                        return (
                                            <tr
                                                key={match.match_id}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => setSelectedMatch(match)}
                                                title="Click to view match details"
                                            >
                                                <td>{match.sport_name}</td>
                                                <td>{match.game_type}</td>
                                                <td>{match.is_counted ? 'Yes' : 'No'}</td>
                                                <td style={{ color }}>{winnerText}</td> {/* only change Winner column */}
                                                <td>{new Date(match.date).toLocaleString()}</td>
                                                <td>{match.status}</td> {/* keep Status as-is */}
                                            </tr>
                                        );
                                    })}
                                </tbody>



                            </Table>

                        )}


                    </>


                )}
            </Modal.Body>

            <Modal
                show={reportModalOpen}
                onHide={() => setReportModalOpen(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Report Match</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p><strong>Match ID:</strong> {selectedMatch?.match_id}</p>
                    <Form.Group>
                        <Form.Label>Report Text</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={reportText}
                            onChange={(e) => setReportText(e.target.value)}
                            placeholder="Enter your report here..."
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setReportModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={async () => {
                            try {
                                // Call your API here
                                await submitReportMatch(selectedMatch.match_id, reportText);

                                // Reset state and close modal
                                setReportText('');
                                setReportModalOpen(false);

                                console.log('Report submitted successfully!');
                            } catch (err) {
                                console.error('Failed to submit report:', err);
                            }
                        }}
                    >
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>




            <Modal.Footer>
                {selectedMatch ? (
                    <Button variant="secondary" onClick={handleBack}>
                        ← Back
                    </Button>
                ) : (
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                )}
            </Modal.Footer>



        </Modal>


    );
};

export default MatchHistoryModal;
